import React  from 'react';
import {Route, BrowserRouter as Router, Switch} from 'react-router-dom';
//components
import Nav from './components/Navbar';
import Aside from './components/Menu/Aside';
import NotFound from './components/NotFound';
import {Home, About, Services, Projects, Project} from './pages/index';

import Cursor from "./components/CustomCursor/Cursor";



import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';


function App() {
  return (
    <Router>
        <div className="App">
            <Cursor/>
            <Nav/>
            <Aside/>
            <Switch>
              <Route exact path="/" component={Home}/>
              <Route exact path="/about" component={About}/>
              <Route exact path="/projects" component={Projects}/>
              <Route exact path="/project/:id" component={Project} />
              <Route exact path="/services" component={Services}/>
              <Route component={NotFound} />
            </Switch>
        </div>
    </Router>

  );
}

export default App;
